<template>
    <div>
        <a-drawer
                :title='title'
                :visible="visible"
                v-bind="drawerConfig"
                :body-style="{ paddingBottom: '80px' }"
                @close="onClose"
        >
            <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
                <a-form-model-item
                        ref="username"
                        label="用户名"
                        prop="username"
                        :help="formErr.username"
                        :validateStatus='!formErr.username||formErr.username==""?"":"error"'
                >
                    <a-input
                            :maxLength=50
                            v-model="form.username"
                            @change="(e) => { formErr.username=''}"
                            @blur="(e) => {  form.username = e.target.value.trim() }"
                    />
                </a-form-model-item>
                <a-form-model-item
                        ref="password"
                        label="密码"
                        prop="password"
                        :help="formErr.password"
                        :validateStatus='!formErr.password||formErr.password==""?"":"error"'
                >
                    <a-input
                            :maxLength=20
                            v-model="form.password"
                            @change="(e) => {formErr.password=''}"
                            @blur="(e) => {form.password = e.target.value.trim();formErr.password='' }"
                    />
                    <span v-if="form.id&&form.id!=''"
                          style="position: absolute;width: 100%;left: 0;top:20px;text-align: right">输入则修改密码，否则密码与原始密码相同</span>
                </a-form-model-item>
                <a-form-model-item
                        ref="email"
                        label="邮箱"
                        prop="email"
                        :help="formErr.email"
                        :validateStatus='!formErr.email||formErr.email==""?"":"error"'
                >
                    <a-input
                            v-model="form.email"
                            @change="(e) => { formErr.email=''}"
                            @blur="(e) => {  form.email = e.target.value.trim() }"
                    />
                </a-form-model-item>
                <a-form-model-item
                        ref="a_role_id"
                        label="角色"
                        prop="a_role_id"
                        :extra="formErr.a_role_id"
                        :validateStatus='!formErr.a_role_id||formErr.a_role_id==""?"":"error"'
                >
                    <a-select v-model="form.a_role_id">
                        <a-select-option :value="item.id" v-for="(item, idx) in role" :key="idx">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>

                <a-form-model-item
                        ref="status"
                        label="状态"
                        prop="status"
                        :extra="formErr.status"
                        :validateStatus='!formErr.status||formErr.status==""?"":"error"'
                >
                    <a-radio-group v-model="form.status">
                        <a-radio :value="1"> 启用</a-radio>
                        <a-radio :value="0"> 停用</a-radio>
                    </a-radio-group>
                </a-form-model-item>
            </a-form-model>
            <div class="drawer-btn">

                <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                    确定
                </a-button>
                <a-button @click="onClose">
                取消
            </a-button>
            </div>
        </a-drawer>
    </div>
</template>

<script>
    import {submitForm, drawerConfig, validator} from "../../../utils/utils"
    import API from "../api";
    let validator2=(rule, value, callback,errval)=> {
        let formerrname=rule.field
        var test = /[\u4E00-\u9FA5]/g
        if( errval!=""){
            callback(new Error(errval))
        } else if(value!=""&& test.test(value) ){
            callback(new Error("请填写字母数字，特殊符号"))
        } else{   callback();}
    }
    export default {
        name: "administratorForm",
        props: ["visible", "title", "editId"],
        data() {
            return {
                drawerConfig,
                role: [],
                form: {
                    username: "",
                    password: "",
                    email: "",
                    a_role_id: "",
                    status: 1
                },
                formErr: {
                    username: "",
                    password: "",
                    email: "",
                    a_role_id: "",
                    status: ""
                },
                rules: {
                    username: [{required: true, message: "请输入用户名称 ",}, {whitespace: true, message: "请输入用户名称 "}, {
                        min: 6,
                        max: 50,
                        message: "请填写6-50个字符",
                    }, {
                        validator: (rule, value, callback) => {
                            validator(rule, value, callback, this.formErr.username)
                        }, trigger: "blur"
                    },],
                    password: [{required: true, message: "请输入密码 ",}, {whitespace: true, message: "请输入密码 "}, {
                        min: 6,
                        max: 50,
                        message: "请填写8-20个字符"
                    }, {validator:(rule, value, callback)=>{validator2(rule, value, callback,this.formErr.password)}  , trigger: "blur"  },
                        // {validator: (rule, value, callback) => { validator(rule, value, callback, this.formErr.password) }, trigger: "blur" },
                    ],
                    email: [{required: true, message: "请输入邮箱 ",}, {whitespace: true, message: "请输入邮箱 "}, {
                        type: "email",
                        message: "请填写正确邮箱"
                    }, {
                        validator: (rule, value, callback) => {
                            validator(rule, value, callback, this.formErr.email)
                        }, trigger: "blur"
                    },],
                    a_role_id: [{required: true, message: "请输入角色 ", trigger: ["change", "blur"]}],
                },
                layout: {
                    labelCol: {span: 4},
                    wrapperCol: {span: 16},
                },
            };
        },
        watch: {
            editId: function (a, b) {
                let that=this
                if (a != "") {
                    API.administrator.GET_EDIT_FORM_ADMINISTRATOR(a).then(res => {
                        let val = res.data.data.info
                        this.form.id = a
                        this.form.password = ""
                        this.form = val
                        this.role = res.data.data.roleList
                        this.rules.password= [{required: false, message: "请输入密码 ",} ,{
                            min: 6,
                            max: 50,
                            message: "请填写8-20个字符"
                        },{validator:(rule, value, callback)=>{ validator2(rule, value, callback,that.formErr.password)}  , trigger: "blur"  },]

                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        mounted() {
            this.getFormData()
        },
        methods: {


            getFormData() {
                API.administrator.GET_FORMDATA().then(res => {
                    this.role = res.data.data.roleList
                })
            },
            onClose() {
                this.$emit("changVisible", false);
                this.form.password = ""
                this.formErr = {username: "", password: "", email: "", a_role_id: "", status: ""},
                    this.rules.password= [{required: true, message: "请输入密码 ",} ,{ min: 6, max: 50, message: "请填写8-20个字符"
                    },{validator:(rule, value, callback)=>{ validator2(rule, value, callback,that.formErr.password)}  , trigger: "blur"  },]
                    this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                if (this.form.id && this.form.id != '') {
                    this.form.password == undefined ? this.form.password = "********" : this.form.password == this.form.password
                }
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        if (this.form.password == "********") {
                            this.form.password = ""
                        }
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.administrator.SUBMIT_ADD_ADMINISTRATOR : url = API.administrator.SUBMIT_EDIT_ADMINISTRATOR
                        submitForm(url, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>

</style>
